import React from 'react';

interface ConditionalRenderProps {
  show?: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Conditionally renders children based on the show prop
 * 
 * @param show - If true, renders children. If false, renders fallback or null
 * @param children - The content to render when show is true
 * @param fallback - Optional content to render when show is false (defaults to null)
 */
const ConditionalRender: React.FC<ConditionalRenderProps> = ({
  show = true,
  children,
  fallback = null,
}) => {
  if (!show) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default ConditionalRender;

